export const AppSettingKey = {
  PRODUCT_SPECIFICATIONS: 'PRODUCT_SPECIFICATIONS',
  PRODUCT_AUTO_GENERATE_NAME_AND_SPEC_BY_AI: 'PRODUCT_AUTO_GENERATE_NAME_AND_SPEC_BY_AI',
}
